
import CardTick from "../../../assets/duotone/CardTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CardTickIcon({ className, dataTestid = "CardTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CardTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
